import React from 'react';
export function PainPoints() {
  return <section className="py-16 px-4 bg-white" data-id="element-128">
      <div className="max-w-4xl mx-auto" data-id="element-129">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-magenta mb-12" data-id="element-130">
          😰 DOES THIS SOUND FAMILIAR?
        </h2>

        <div className="grid md:grid-cols-2 gap-8 items-center bg-light-pink rounded-3xl p-8 shadow-xl border-4 border-pink-100" data-id="element-131">
          <div className="space-y-6" data-id="element-132">
            <p className="text-lg text-gray-700" data-id="element-133">
              Your little one's birthday is coming up and{' '}
              <strong className="text-magenta" data-id="element-134">
                once again you don't know where to start.
              </strong>
            </p>
            <p className="text-lg text-gray-700" data-id="element-135">
              You search for ideas on Pinterest and everything looks gorgeous…
              but impossible to make.
            </p>
            <p className="text-lg text-gray-700" data-id="element-136">
              You call a decorator and they quote you{' '}
              <strong className="text-orange-500" data-id="element-137">
                $200, $300, even $500.
              </strong>
            </p>
            <p className="text-lg text-gray-700" data-id="element-138">
              You rush to the store, buy the first things you find, and in the
              end the party doesn't turn out how you imagined.
            </p>
            <p className="text-xl font-bold text-gray-800" data-id="element-139">
              And the worst part: your child deserves something special.
              Something unique. Something they'll remember forever.
            </p>
            <div className="bg-white p-4 rounded-2xl border-l-4 border-pink-400 shadow-sm" data-id="element-140">
              <p className="text-pink-800 italic font-medium" data-id="element-141">
                💔 That moment when you see the disappointment on your little
                one's face… it hurts more than any budget.
              </p>
            </div>
          </div>

          <div className="relative" data-id="element-142">
            <div className="absolute inset-0 bg-orange-300 rounded-3xl transform rotate-3 scale-105" data-id="element-143"></div>
            <img src="https://cdn.magicpatterns.com/uploads/vCJ4zGkMfyGSHpq7RPXTuH/FOTO_FRUSTADA.png" alt="Frustrated mother organizing a party" className="relative z-10 rounded-3xl shadow-lg w-full object-cover border-4 border-white" data-id="element-144" />
          </div>
        </div>

        <div className="mt-12 text-center bg-orange-100 rounded-3xl p-8 border-4 border-orange-300 shadow-lg transform hover:-translate-y-1 transition-transform" data-id="element-145">
          <h3 className="text-2xl md:text-3xl font-bold text-orange-800" data-id="element-146">
            What if you could create that dream party yourself, from home, in
            minutes, and for a fraction of the price? ✨
          </h3>
        </div>
      </div>
    </section>;
}